import { render, staticRenderFns } from "./RenewStatiscal.vue?vue&type=template&id=42853ef3&scoped=true&"
import script from "./RenewStatiscal.vue?vue&type=script&lang=js&"
export * from "./RenewStatiscal.vue?vue&type=script&lang=js&"
import style0 from "./RenewStatiscal.vue?vue&type=style&index=0&id=42853ef3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42853ef3",
  null
  
)

export default component.exports